import React, { useState } from "react";
import { FaFacebookSquare, FaWindowClose, FaWindows } from "react-icons/fa";
import { ImGoogle2 } from "react-icons/im";
import axios from "axios";
import { useHistory } from "react-router-dom";

const SignUp1 = ({ closeModal }) => {
  const history = useHistory();

  const [user, setUser] = useState({
    name: "",
    email: "",

    password: "",
    password2: "",
  });

  const { name, email, password, password2 } = user;

  const onChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const PostData = async () => {
    const response = await axios
      .post("/api/v1/auth/register", {
        name,
        email,

        password,
      })
      .then((response) => {
        console.log(response.data);
        window.alert("Registration Successful");
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));

        history.push("/buystakes");
      })
      .catch((err) => console.log(err.response.data.error));
  };

  const OnSubmit = (e) => {
    e.preventDefault();
    if (name === "" || email === "" || password === "") {
      window.alert("Please enter all the details");
    } else if (password !== password2) {
      console.log("Please enter the same password");
    } else {
      console.log("Submitted");
    }
  };

  const clickHandler = () => {
    closeModal(false);
  };

  return (
    <div className="signModal fixed-div">
      <div id="SignUp" className="pt-5">
        <div className="m-5 mt-5 pt-5 signMargin" style={{ width: "110%" }}>
          <div
            className="d-flex justify-content-end pt-5 mt-5 btnMargin"
            onClick={clickHandler}
          >
            <button
              type="button"
              className="btn-close shadow-none mt-5"
              aria-label="Close"
            ></button>
          </div>
          <div className="d-block text-center">
            <img
              src="/assests/logo2.png"
              alt="KIBI Sport"
              className="fluid-img"
            />
          </div>
          <div className="text-center">
            <h1 className="mt-4 modalHeader">Sign Up</h1>
            <form method="POST" onSubmit={OnSubmit}>
              <input
                type="text"
                name="name"
                value={name}
                onChange={onChange}
                placeholder="Name "
                className="input-group p-3 rounded border border-secondary"
              />
              <br />
              <input
                type="email"
                name="email"
                value={email}
                onChange={onChange}
                placeholder="Email Address"
                className="input-group p-3 rounded border border-secondary"
              />

              <br />
              <input
                type="password"
                name="password"
                value={password}
                onChange={onChange}
                placeholder="Password"
                className="input-group p-3 rounded border border-secondary"
              />
              <br />
              <input
                type="password"
                name="password2"
                value={password2}
                onChange={onChange}
                placeholder="Confirm Password"
                className="input-group p-3 rounded border border-secondary"
              />

              <div className="mt-3 d-md-flex justify-content-start align-items-center">
                <input type="checkbox" /> &nbsp;
                <label>I accept the Terms & Conditions</label>
              </div>
              <br />

              <div>
                <button
                  type="submit"
                  onClick={PostData}
                  className="loginBtn p-2 rounded"
                >
                  Sign Up
                </button>
              </div>
            </form>

            <p className="fw-bold text-secondary fs-4">OR</p>
            <div className="d-flex justify-content-center align-items-center gap-1">
              <FaFacebookSquare color="#395998" size={45} />
              <ImGoogle2 color="#EA4335" size={40} />
            </div>
            <a className="textLink textSky">Already Have an Account?</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp1;
